/*--------------------------------------------------------------
>>> TABLE OF CONTENTS:
----------------------------------------------------------------
1.0 - Search Filter
--------------------------------------------------------------*/
/* eslint-disable */

// 1.0 - Search Filter
export function facetSearch() {

    jQuery(document).on('facetwp-loaded', function() {
      
        //const loadmore = document.querySelector('.facetwp-load-more');

        jQuery.each(FWP.facets, function(name, vals) {

            if (vals == 'lifestyle') {
                vals = 'blog';
            } else if (vals == 'shop') {
                vals = 'download';
            } else if (vals == 'favorite-things') {
                vals = 'favorite-things callout-grid__list count-4';
            }

            if(name === 'search_filter') {
	           
                if (FWP.facets['search_filter'].length > 0) {
                    jQuery('.facetwp-template').attr('class', 'facetwp-template search-list');
                    jQuery('.archive__pagination').show();
                    jQuery('.facetwp-template').addClass('archive__list-' + vals);
                } else {
                    jQuery('.facetwp-template').attr('class', 'facetwp-template search-list');
                    jQuery('.facetwp-template').addClass('archive__list-default');
                    jQuery('.archive__pagination').hide();
                }
            }
        });

        searchButton();
    });
}

export function searchButton() {
    const facetSearch   = document.querySelectorAll('.js-facet-search');

    function reloadPageWithFacet(facetName, facetValue) {
        var currentURL = window.location.href;
        var separator = currentURL.includes('?') ? '&' : '?';
        var facetParam = facetName + '=' + encodeURIComponent(facetValue);
        var newURL = currentURL + separator + facetParam;
        window.location.href = newURL;
    }

    if(facetSearch) {
        facetSearch.forEach(function(facet) {
            facet.addEventListener('click', function(e) {
                e.preventDefault();
                const facetData = facet.dataset.facet;
                reloadPageWithFacet('_search_filter', facetData);
            });
        });
    }
}
